var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Scene(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 27v38h50V27H13zm46 34H17V37h5.91l-5.47-6H24l5.48 6h7.93L32 31h6.67l5.47 6h7.94l-5.48-6h7l5.4 6v24zm-2.47-46.8L13 27l-2.34-8L54.19 6.24l2.34 7.96z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Scene.347c58dc.svg";
export { SvgK1Scene as ReactComponent };